<template>
  <el-dialog
    :title="$t('pages.equipment.text160')"
    :visible.sync="addrVisible"
    width="1000px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div>
      <div id="addr-map">
        <DiluMap :phoneAddr="phoneAddr" :bikeAddr="bikeAddr" :opeMap="opeMap" />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.close") }}</el-button>
      <el-button type="primary" @click="handleClose">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DiluMap from "../../../../components/pubilc/dilu-map.vue";
export default {
  data() {
    return {
      opeMap: false,
    };
  },
  watch: {
    addrVisible(newValue) {
      if (newValue) {
        this.opeMap = true;
        // console.log(this.phoneAddr);
      }
    },
  },
  components: {
    DiluMap,
  },
  props: ["addrVisible", "phoneAddr", "bikeAddr"],
  methods: {
    handleClose() {
      this.opeMap = false;
      this.$emit("addrClose");
    },
  },
};
</script>

<style scoped>
#addr-map {
  width: 100%;
  height: 500px;
}
</style>